import { render, staticRenderFns } from "./PageOffsetLimitComponent.vue?vue&type=template&id=a665e638&scoped=true&"
import script from "./PageOffsetLimitComponent.vue?vue&type=script&lang=js&"
export * from "./PageOffsetLimitComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageOffsetLimitComponent.vue?vue&type=style&index=0&id=a665e638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a665e638",
  null
  
)

export default component.exports